import * as foundations from './foundations';
import * as components from './components';

import type { PaymentElementThemeType } from '../../../@types';

/**
 * Basic styling theme for PaymentElement, used in absence of a custom theme.
 */
export const defaultTheme: PaymentElementThemeType = {
  globalStyles: {
    body: {
      fontFamily: 'body',
      lineHeight: '24px',
    },
  },
  colorMode: 'light',
  foundations,
  components,
};
